import {ComboboxItem, ComboboxProvider, SelectProvider} from '@ariakit/react'
import {
    SelectComboboxInput,
    SelectComboboxList,
    SelectComboboxPopover,
    SelectTrigger
} from '@components/ui/select-atoms/SelectAtoms.tsx'
import {Checkbox} from '@components/commons/checkbox/ChekBox.tsx'
import {FC, useState} from 'react'
import {useTranslation} from '@/translations/i18n.tsx'
import {StyledSelectItem} from '@components/commons/multi-select-checkbox/style.ts'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'

interface MultiSelectCheckboxProps {
    value: string[]
    onChange: (value: string[]) => void
    options: {label: string; value: string}[]
    placeholder: string
}
export const MultiSelectCheckbox: FC<MultiSelectCheckboxProps> = ({value, onChange, options, placeholder}) => {
    const {t} = useTranslation()
    const [comboboxValue, setComboboxValue] = useState('')
    const searchOptions = options.filter(option => option.label.toLowerCase().includes(comboboxValue.toLowerCase()))

    return (
        <ComboboxProvider value={comboboxValue} setValue={setComboboxValue} resetValueOnHide>
            <SelectProvider setValue={onChange} value={value} defaultValue={[]}>
                <SelectTrigger
                    displayValue={value =>
                        value.length == 1
                            ? options.find(option => option.value == value)?.label
                            : t('commons:x_selected', {count: value.length})
                    }
                    placeholder={placeholder}
                />
                <SelectComboboxPopover sameWidth={false}>
                    <SelectComboboxInput />
                    {searchOptions.length == 0 ? (
                        <InputHelpText helpText={t('commons:no_results')} />
                    ) : (
                        <SelectComboboxList>
                            {searchOptions.map(option => (
                                <StyledSelectItem
                                    render={<ComboboxItem />}
                                    value={option.value}
                                    key={option.value}
                                    selectItemContentClassName="content"
                                >
                                    {option.label}
                                    <Checkbox
                                        id="selected"
                                        checked={value.includes(option.value)}
                                        onChange={() => undefined}
                                    />
                                </StyledSelectItem>
                            ))}
                        </SelectComboboxList>
                    )}
                </SelectComboboxPopover>
            </SelectProvider>
        </ComboboxProvider>
    )
}
